export default "__VITE_ASSET__Cer7vYwY__"